module.exports = __webpack_public_path__ + "536932be907ed6f62e4281747e3fabae.pdf";